import React from 'react';
import { SmartCaptcha, InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import './SmartCaptcha.scss';
import ErrorText from '../ErrorText/ErrorText';
import { SmartCaptchaController } from './useSmartCaptcha';

interface Props {
  captcha: SmartCaptchaController;
  className?: string;
}

/**
 * Виджет Yandex SmartCaptcha. Конфиг и состояние берёт из контроллера useSmartCaptcha.
 * Если капча не сконфигурирована/выключена — ничего не рендерит (форма не блокируется).
 */
const SmartCaptchaBox = ({ captcha, className }: Props) => {
  if (!captcha.enabled) {
    return null;
  }

  return (
    <div className={`smart-captcha-box${className ? ` ${className}` : ''}`}>
      {captcha.mode === 'invisible' ? (
        <InvisibleSmartCaptcha
          key={captcha.resetKey}
          sitekey={captcha.sitekey}
          visible={captcha.visible}
          onSuccess={captcha.onSuccess}
          onTokenExpired={captcha.onTokenExpired}
          onNetworkError={captcha.onNetworkError}
          onChallengeHidden={captcha.onChallengeHidden}
        />
      ) : (
        <SmartCaptcha
          key={captcha.resetKey}
          sitekey={captcha.sitekey}
          onSuccess={captcha.onSuccess}
          onTokenExpired={captcha.onTokenExpired}
          onNetworkError={captcha.onNetworkError}
        />
      )}
      {captcha.captchaError ? ErrorText(captcha.captchaError, true) : null}
    </div>
  );
};

export default SmartCaptchaBox;
